export const PRIVATE_MENU_ICONS = {
  close: 'home/navbar/menu/Close.svg',
  drop: 'home/navbar/menu/arrow-drop.svg',
  chevron: 'home/navbar/menu/arrow-down.svg',
  copy: 'home/navbar/menu/copy.svg',
} as const;